export default {
  data() {
    return {
      status: { pendente: 1, aprovado: 2, rejeitado: 3, },
      contrato: { profissional: 1, eps: 2, },
      horas: { normal: 1, },
    };
  },

  methods: {
    /**
     * @param {string} msg
     * @param {string} group
     */
    notificar(text, group, type = 'warn') {
      this.$notify({
        group,
        title: 'Atenção!',
        text,
        type
      });
    },

    /**
     * @param {Number} horas
     * @param {Number} minutos
     */
    getSegundos(horas, minutos) {
      return (Number(horas) * 3600) + (Number(minutos) * 60);
    },

    /**
     *
     * @param {Number} segundos
     */
    getHoras(segundos) {
      return segundos / 3600;
    },

    /**
     *
     * @param {Number} value
     */
    getDecimal(value) {
      if (value != 0) {
        return (Number(value) * 100) / 60;
      }
      return 0;
    },

    /**
     *
     * @param {Number} value
     */
    getMinutos(value) {
      if (value != 0) {
        return ((Number(value) * 60) / 100).toFixed(0);
      }
      return 0;
    },

    /**
     * @param {String} string
     */
    formatarNome(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    /**
     * @param {String} value
     */
    formatarData(value) {
      return new Date(value).toLocaleDateString();
    },

    /**
     * @param {String} value
     */
    formatarDataUS(value) {
      return new Date(value).toISOString().slice(0,10);
    },

    /**
     *
     * @param {Number} value
     */
    getDuracao(value = 0) {
      const horas = this.getHoras(Number(value)).toFixed(2);
      const tempo = horas.split('.');
      const hora = tempo[0] < 10 ? ('00' + tempo[0]).slice(-2) : tempo[0];

      return `${hora}:${('00' + this.getMinutos(tempo[1])).slice(-2)}`;
    },

    async validarApontamento(id, duracao_antiga, quantidade, tipoHora, data, group) {
      try {
        const { data: response } = await this.$http.get('/apontamento/horas', { params: { data } });

        if (response.tipo_contratacao == 1) {
          return await this.validarProfissional(id, duracao_antiga, quantidade, tipoHora, group, response.horas);
        }

        return this.validarEPS(duracao_antiga, quantidade, group, response.horas);
      } catch(e) {
        console.log(e);
        this.notificar('Ocorreu um erro. Entre em contato com o administrador do sistema.', group);
        return false;
      }
    },

    async validarProfissional(id, duracao_antiga, quantidade, tipoHora, group, response) {
      if (id) {
        const { data: response } = await this.$http.get(`/apontamento/${id}`);

        if (!(response.tipo_hora_id != this.horas.normal && tipoHora == this.horas.normal)) {
          quantidade = quantidade - Number(duracao_antiga);
        }
      }

      // if (tipoHora === 1 && ((response.qtde_lancada_normal + quantidade) > Number(response.horas_liberadas))) {
      //   this.notificar(`Você já ultrapassou sua capacidade diária de apontamentos normais ${this.getDuracao(response.horas_liberadas)}.`, group);
      //   return false;
      // }

      if (quantidade + Number(response.qtde_lancada) >= (24 * 3600)) {
        this.notificar('Você não pode apontar mais que 24 horas em um dia.', group);
        return false;
      }

      return true;
    },

    validarEPS(duracao_antiga, quantidade, group, response) {
      if (duracao_antiga) {
        quantidade = quantidade - Number(duracao_antiga);
      }

      if ((Number(response.qtde_lancada) + quantidade) > Number(response.horas_liberadas)) {
        this.notificar(`Você já ultrapassou sua capacidade diária de apontamentos ${this.getDuracao(response.horas_liberadas)}.`, group);
        return false;
      }

      return true;
    },

    calculaPorcentagem(valorTotal, valorReal) {
      if (valorTotal === 0 || isNaN(valorTotal) || isNaN(valorReal)) {
        return 0;
      }

      return (valorReal * 100 / valorTotal).toFixed(0);
    },

    getClasseDivergencia(valorTotal, valorReal) {
      if (valorTotal === 0 || isNaN(valorTotal) || isNaN(valorReal)) {
        return '';
      }

      const divergencia = valorTotal - valorReal;

      if (divergencia <= 900 && divergencia >= (900 * -1)) {
        return 'text-success';
      }

      return divergencia <= 1800 && divergencia >= (1800 * -1) ? 'text-warning' : 'text-danger';
    },

    getTitleDivergencia(valorTotal, valorReal) {
      if (valorTotal === 0 || isNaN(valorTotal) || isNaN(valorReal)) {
        return '';
      }

      const divergencia = valorTotal - valorReal;

      if (divergencia <= 900 && divergencia >= (900 * -1)) {
        return 'Não há divergência entre apontamentos e REP';
      }

      return divergencia <= 1800 && divergencia >= (1800 * -1) ? 'Há mais de 15 minutos de divergência' : 'Há mais de 30 minutos de divergência';
    },

    removerDias(date, qtde) {
      const data = new Date(date).setDate(new Date(date).getDate() - qtde);
      return new Date(data);
    },
  },
};
